module.exports = {
  courseDetailRen: {
    title: "课程详情",
    requiredParams: {},
    optionalParams: {}
  },
  certificate: {
    title: "我的证书",
    requiredParams: {},
    optionalParams: {}
  },
  privacyPolicy: {
    title: "隐私政策",
    requiredParams: {},
    optionalParams: {}
  },
  userAgreement: {
    title: "用户协议",
    requiredParams: {},
    optionalParams: {}
  },
  topicStudyResult: {
    title: "做题结果",
    requiredParams: {
      operateCourseId: "运营课程包id"
    },
    optionalParams: {
      name: "面包屑的标题名字",
      coursePackageId: "课程包id",
      testPaperNo: "试卷编号",
      atomicCourseId: "原子课id",
      knowledgeId: "知识点Id"
    }
  },
  topicStudy: {
    title: "做题",
    requiredParams: {
      operateCourseId: "运营课程包id"
    },
    optionalParams: {
      name: "面包屑的标题名字",
      coursePackageId: "课程包id",
      testPaperNo: "试卷编号",
      atomicCourseId: "原子课id",
      knowledgeId: "知识点Id",
      errorOrCorrect: "1看全部，2只看正确，3只看错误", //查看详情的时候用
      questionId:
        "题目的ID,用来定位到某个题目(不传或没有找到题目ID都是从第一题开始)"
    }
  },
  examDetails: {
    title: "考试回顾",
    requiredParams: {
      testPaperId: "试卷id",
      testPaperNo: "试卷编号",
      testingId: "测评id"
    },
    optionalParams: {
      name: "面包屑的标题名字",
      questionId:
        "题目的ID,用来定位到某个题目(不传或没有找到题目ID都是从第一题开始)",
      errorOrCorrect: "1看全部，2只看正确，3只看错误"
    }
  },
  exam: {
    title: "考试",
    requiredParams: {
      //必填参数
      testPaperId: "试卷id",
      testPaperNo: "试卷编号",
      testingId: "测评id",
      againFlag: "是否为重新挑战(1:重新挑战, 0:不是,不能未空)"
    },
    optionalParams: {
      name: "面包屑的标题名字"
    }
  },
  forgetPassword: {
    title: "忘记密码",
    requiredParams: {},
    optionalParams: {}
  },
  bindCourseCard: {
    title: "开通课程",
    needLogin: true,
    requiredParams: {},
    optionalParams: {}
  },
  loginIndex: {
    title: "登录",
    requiredParams: {},
    optionalParams: {}
  },
  courseIntroduce: {
    title: "课程介绍",
    requiredParams: {
      id: "课程id"
    },
    optionalParams: {}
  },
  courseDetail: {
    title: "课程详情",
    requiredParams: {
      operateCourseId: "教研课程id",
      courseType: "课程类型区分课程包和原子课",
      assistType: "区分课程包和试卷",
      name: "教研课程名称"
    },
    optionalParams: {
      knowledgeId: "知识点id主要作为区分上次已学",
      atomicCourseId: "原子课id",
      coursePackageId: "运营包id"
    }
  },
  demo: {
    title: "演示",
    requiredParams: {},
    optionalParams: {}
  },
  index: {
    title: "首页",
    requiredParams: {}
  },
  studyIndex: {
    title: "学习首页",
    needLogin: true,
    requiredParams: {}
  },
  mineIndex: {
    title: "我的首页",
    needLogin: true,
    requiredParams: {}
  },
  examIndex: {
    title: "考试首页",
    needLogin: true,
    requiredParams: {}
  },
  topicWrong: {
    title: "错题本",
    needLogin: true,
    requiredParams: {}
  },
  examResult: {
    title: "考试结果",
    needLogin: true,
    requiredParams: {
      testPaperId: "试卷id",
      testPaperNo: "试卷编号",
      testingId: "测评id"
    },
    optionalParams: {
      //可选参数
    }
  }
};
